import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'

import { TransferCardAddress } from './transfer-card-address'
import { TransferCardTop } from './transfer-card-top'

import type { TransferFlowReatom } from '../../../atoms/transfer-flow'
import type { WalletModel } from '@root/entities/wallet/atoms'

type TransferCardProps = {
  wallet: WalletModel
  model: TransferFlowReatom
}

export const TransferCard: React.FC<TransferCardProps> = ({
  wallet,
  model,
}) => {
  const { t } = useTranslation()

  return (
    <Root>
      <TransferCardTop wallet={wallet} model={model} />

      <Separator>
        <SeparatorLineStart />
        <SendTo>{t('transfer.send-to')}</SendTo>
        <SeparatorLineEnd />
      </Separator>

      <AddressContainer>
        <TransferCardAddress model={model} selectedWallet={wallet} />
      </AddressContainer>
    </Root>
  )
}

const Root = styled.div`
  border-radius: 16px;
  border: 1px solid var(--backgroundA-2);
  background: var(--backgroundA-3);
`

const SendTo = styled(Typography).attrs({
  variant: 'body2-regular',
  component: 'div',
})`
  border-radius: 64px;
  background: var(--backgroundA-3);

  color: var(--text-9);
  padding-inline: 9px;
`

const Separator = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
`

const SeparatorLineStart = styled.div`
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    var(--grayA-3) 100%
  );
`
const SeparatorLineEnd = styled.div`
  height: 1px;
  background: linear-gradient(
    90deg,
    var(--grayA-3) 0%,
    rgba(255, 255, 255, 0) 100%
  );
`

const AddressContainer = styled.div`
  padding-block: 12px;
  padding-inline: 12px;
`
